'use client';

import { cn } from '@shared/components/shadcn';
import { Success } from '@shared/icons';
import { forwardRef } from 'react';
import type { MessageType } from '../types';

type CheckboxDisplayProps = {
  checked?: boolean;
  helpMessageType?: MessageType;
  className?: string;
};

const CheckboxDisplay = forwardRef<HTMLDivElement, CheckboxDisplayProps>(({ checked = false, helpMessageType, className }, ref) => {
  const classes = cn(
    'h-7 w-7 rounded-sm border border-gray-300 flex-shrink-0 flex items-center justify-center',
    'data-[state=checked]:bg-foreground data-[state=checked]:border-foreground data-[state=checked]:text-white',
    checked && 'bg-foreground border-foreground',
    helpMessageType === 'error' && 'border-error-foreground',
    className
  );

  return (
    <div ref={ref} data-state={checked ? 'checked' : 'unchecked'} className={classes} aria-hidden="true" data-testid="checkbox-display">
      {checked && <Success className="h-5 w-5 text-white dark:text-black" />}
    </div>
  );
});

CheckboxDisplay.displayName = 'CheckboxDisplay';

export { CheckboxDisplay };
